import { BANNER_TYPES } from "./__styles__/Banner";
import { Disclaimer } from "./__styles__/Disclaimer";
import Banner from "./Banner";

export default ({
  message,
  testId,
  margin = true,
}: {
  message: string;
  testId?: string;
  margin?: boolean;
}) => {
  return (
    <Banner
      testId={testId}
      type={BANNER_TYPES.NEUTRAL}
      style={margin ? { marginTop: "16px" } : {}}
    >
      <Disclaimer markdown={message} />
    </Banner>
  );
};
